import { useNavigate } from "react-router-dom";
import PageContainer from "../../components/PageContainer";
import ProblemCard from "../problems/ProblemCard";
import ProgressPreview from "../progress/ProgressPreview";
import LandingCard from "./LandingCard";

const LandingPage = () => {
  const navigate = useNavigate();

  const handleProgressClick = () => {
    navigate("progress");
  };

  return (
    <PageContainer>
      <LandingCard>
        <ProblemCard />
      </LandingCard>
      <LandingCard onClick={handleProgressClick}>
        <ProgressPreview />
      </LandingCard>
    </PageContainer>
  );
};

export default LandingPage;
